
import verb from '../../lib/verb';

import OBase from './OBase';
import * as Geometry from '../geometry';
import * as GHMath from '../../math';

export default class EInterpolate extends OBase {
  update () {
    let pointsTree = this.getVector3Input('Vertices', false);
    let degreeTree = this.getFloatInput('Degree');
    let periodicTree = this.getBoolInput('Periodic');

    let outputCurve = this.outputs['Curve'].paramObject;
    let outputLength = this.outputs['Length'].paramObject;

    let dataTrees = [pointsTree, degreeTree, periodicTree];
    let outDataTrees = [];
    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    let outputCurveTree = new Geometry.DataTree();
    let outputLengthTree = new Geometry.DataTree();

    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      let paths = this.createPolyline(outDataTrees[0].branches[i], outDataTrees[1].branches[i][0], outDataTrees[2].branches[i][0]);
      outputCurveTree.add(paths, outDataTrees[0].paths[i]);

      /*
      // debug
      if (!this.ghGeometryObject.hidden) {
        paths.forEach(path => {
          let points = path.map(p => new THREE.Vector3(p.X, 0, p.Y))
          global.debugger.addLine(points)
        })
      }
      */

      let length = 0;
      let path = paths[0];
      for (let i = 0, n = path.length - 1; i < n; i++) {
        let p0 = path[i];
        let p1 = path[i + 1];
        let dx = p0.X - p1.X;
        let dy = p0.Y - p1.Y;
        length += Math.sqrt(dx * dx + dy * dy);
      }
      outputLengthTree.add(length, outDataTrees[0].paths[i]);
    }

    outputCurve.value = outputCurveTree;
    outputLength.value = outputLengthTree;
  }

  getKnotCount (order, cvCount) {
    // return order + cvCount - 2
    return order + cvCount - 2;
  }

  // order - degree + 1
  // cvCount - # of control points
  // delta - (>0, default=1.0) spacing between knots
  makePeriodicUniformKnotVector (order, cvCount, delta = 1.0) {
    let knotCount = this.getKnotCount(order, cvCount);

    let knots = [];

    for (let i = order - 2, k = 0.0; i < knotCount; i++, k += delta) {
      knots[i] = k;
    }

    for (let i = order - 3, k = -delta; i >= 0; i--, k -= delta) {
      knots[i] = k;
    }

    return knots;
  }

  createPolyline (points, degree, periodic) {
    let path = [];

    /*
    global.debugger.clear()
    global.debugger.addPoints(points.map(p => {
      let copied = p.clone()
      copied.z *= -1
      return copied
    }), new THREE.Color(0x00ff00))
    */

    if (periodic && points.length > 0) {
      points.push(points[0]);
    }

    let curve = verb.geom.NurbsCurve.byPoints(points.map(p => [p.x, p.y, p.z]), Math.min(points.length - 1, degree));
    let samples = curve.tessellate(0.1); // adaptive tessellation

    let n = periodic ? samples.length - 1 : samples.length;
    for (let j = 0; j < n; j++) {
      let sample = samples[j];
      path.push(new ClipperLib.DoublePoint(sample[0], sample[1]));
    }

    path.reverse();
    if (GHMath.isClockwise(path)) {
      path.reverse();
    }

    return [path];
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/EInterpolate.js